// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ff4c4aa6","453":"2e76bdc8","667":"9edd8530","977":"cb662fd6"}[chunkId] + ".chunk.js";
};